import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';
import ReactConfetti from 'react-confetti';

const Confetti = (): React.ReactElement => {
  return (
    <>
      <ReactConfetti
        {...{
          width: window.innerWidth,
          height: window.innerHeight,
          style: { zIndex: 9999 },
          gravity: 0.2,
          numberOfPieces: 1500,
          initialVelocityX: 13,
          initialVelocityY: 50,
          wind: 0,
          opacity: 70,
          recycle: false,
        }}
      />
    </>
  );
};

export const TargetContinuationModal = ({
  hide,
  isShow,
  keepPeriod,
}: {
  isShow: boolean;
  hide: () => void;
  keepPeriod: number;
}): React.ReactElement => {
  const year = Math.floor(keepPeriod / 12);
  const month = keepPeriod % 12;

  return (
    <>
      {isShow && <Confetti />}
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-lg text-center">
            この目標を
          </div>
          <div className="font-bold text-red-550 text-2xl text-center">
            {`${year ? `${year}年` : ''}${
              month ? `${month}ヶ月` : ''
            }継続できてます`}
          </div>
          <img
            src="/static/images/advisor/achievement_continuation.svg"
            alt="継続"
            className={`m-8`}
          />
          <div className="mt-4">
            <div className="text-base text-bluegray-700 text-center">
              継続は力なり！
            </div>
            <div className="text-base text-bluegray-700 text-center">
              この調子で一緒に続けていきましょう
            </div>
          </div>
          <div className="m-4 flex flex-col">
            <button
              className="text-sm text-bluegray-500 py-2 flex flex-row items-center justify-center mt-2"
              onClick={hide}>
              閉じる
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
